import { render } from "./PulseNewsView.vue?vue&type=template&id=636c74f7&scoped=true"
import script from "./PulseNewsView.vue?vue&type=script&lang=js"
export * from "./PulseNewsView.vue?vue&type=script&lang=js"

import "./PulseNewsView.vue?vue&type=style&index=0&id=636c74f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636c74f7"]])

export default __exports__